import { useCallback } from "react";

import { createEmailVerificationLink } from "../../api/account/requests";
import { useSetFlashMessageId } from "../flashMessage/store";

export const useSendEmailVerification = () => {
  const setFlashMessageId = useSetFlashMessageId();
  const handler = useCallback(async () => {
    try {
      await createEmailVerificationLink()

      setFlashMessageId({ id: "account.email_verification.link_sent_success" }, "success")
    } catch (error) {
      setFlashMessageId({ id: "api.network_error" }, "error")
      console.error("Create email verification error", error)
    }
  }, [setFlashMessageId]);

  return handler
}